import type { ReactNode } from "react";

import { ErrorBoundary } from "@/components/error-boundary";

interface EditorWithPreviewLayoutProps {
  editor: ReactNode;
  preview: ReactNode;
}

/**
 * Two-column editor layout: editor on the left, sticky live preview on the right.
 * Replaces the legacy withPreview HOC + react-sticky.
 */
export function EditorWithPreviewLayout({
  editor,
  preview,
}: EditorWithPreviewLayoutProps) {
  return (
    <div className="grid grid-cols-1 gap-8 xl:grid-cols-[minmax(0,1.5fr)_380px] xl:items-start">
      <section>{editor}</section>
      <aside className="xl:sticky xl:top-24 xl:self-start">
        <ErrorBoundary>{preview}</ErrorBoundary>
      </aside>
    </div>
  );
}
